import { ControlCodes } from '@bcube/shared/constants';
import { BookOpen, Shield, Users } from 'lucide-react';
import type { ModuleConfig } from './types';

export const adminModule: ModuleConfig = {
  id: 'admin',
  title: 'Módulo Admin',
  description: 'Esse módulo é responsável pelo controle de acesso, usuários e perfis.',
  basePath: '/admin',
  icon: Users,
  navigation: [
    {
      name: 'Usuários',
      pathname: '/admin/users',
      icon: <Users size={16} className="text-muted-foreground" />,
      code: ControlCodes.admin_user,
    },
    {
      name: 'Perfis',
      pathname: '/admin/profiles',
      icon: <BookOpen size={16} className="text-muted-foreground" />,
      code: ControlCodes.admin_profile_view,
    },
    {
      name: 'Controle de acesso',
      pathname: '/admin/control',
      icon: <Shield size={16} className="text-muted-foreground" />,
      code: ControlCodes.admin_control,
    },
  ],
  landingActions: [
    {
      title: 'Usuários',
      href: '/admin/users',
      code: ControlCodes.admin_user,
      icon: Users,
      iconForeground: 'text-sky-700',
      iconBackground: 'bg-sky-50',
      description:
        'Gerencie o cadastro, edição e exclusão de usuários do sistema, além de visualizar seus detalhes e status de acesso.',
    },
    {
      title: 'Perfis',
      href: '/admin/profiles',
      code: ControlCodes.admin_profile_view,
      icon: BookOpen,
      iconForeground: 'text-teal-700',
      iconBackground: 'bg-teal-50',
      description:
        'Configure perfis de acesso, definindo permissões e regras específicas para diferentes grupos de usuários.',
    },
    {
      title: 'Controle de acesso',
      href: '/admin/control',
      code: ControlCodes.admin_control,
      icon: Shield,
      iconForeground: 'text-purple-700',
      iconBackground: 'bg-purple-50',
      description:
        'Administre as regras de autorização do sistema, vinculando usuários e perfis às funcionalidades disponíveis.',
    },
  ],
};
